'use strict';

angular.module('imagetrend.components')
    .directive('hlpMessages', ['$timeout', '$window', '$sce', function ($timeout, $window, $sce) {
        return {
            restrict: 'AE',
            scope: {
                messages: '=',
                type: '@?',
                focusOnChange: '=?'
            },
            replace: true,
            templateUrl: 'templates/messages/messages.html',
            link: function (scope, elem, attrs, ctrl) {
                if (!attrs.type) { attrs.type = "info"; };
                if (!attrs.focusOnChange) { attrs.focusOnChange = false; } else { if (attrs.focusOnChange == 'true') { attrs.focusOnChange = true; } else { attrs.focusOnChange = false; } }

                scope.show = function() {
                    return scope.messages != null && scope.messages.length > 0;
                }

                scope.trust = function(message) {
                    return $sce.trustAsHtml(message);
                }

                if (scope.focusOnChange) {
                    scope.$watch("messages", function (newValue, oldValue) {
                        if (newValue != null && newValue.length > 0) {
                            $window.scrollTo(0, 0);
                        }
                    }, true);
                }

            }
        };
    }])
;